import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

interface MultiselectBox {
    open: boolean;
    classes: string;
}

interface MultiselectButton {
    classes: string;
    value: string;
}

interface MultiselectIcon {
    classes: string;
    innerHTML: string;
    style: string;
}

interface MultiselectGroup {
    classes: string;
}

type MultiselectChecks = MultiselectGroup;
type MultiselectLabels = MultiselectGroup;

interface OverridesInterface {
    button?: MultiselectButton;
    caret?: MultiselectIcon;
    dropdown?: MultiselectBox;
    group?: MultiselectGroup;
    checkboxes?: MultiselectChecks;
    labels?: MultiselectLabels;
}

type AdditionsInterface = OverridesInterface;

interface AnyListInput extends BasicFormModel {
    [x:string]: any;
}

interface BasicFormModel {
    label: string;
    value: any;
}

@Component({
  selector: 'ng-common-multiselect-input',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiselectInputComponent implements OnInit {
    @Input() formName: string;
    @Input() outputType: string;
    @Input() inputList: AnyListInput[];
    @Input() inputProperty: string = 'value';
    @Input() isRequired: boolean;
    @Input() formLabel: string;

    @Input() overrides: OverridesInterface;
    @Input() additions: AdditionsInterface;

    @Input() inputModel: any[];
    @Output() inputModelChange: EventEmitter<any[]> = new EventEmitter();

    public _selected: any[] = [];
    public _object: OverridesInterface = {
        button: {
            classes: '',
            value: ''
        },
        caret: {
            classes: '',
            innerHTML: '',
            style: ''
        },
        dropdown: {
            classes: '',
            open: false
        },
        group: {
            classes: ''
        },
        checkboxes: {
            classes: ''
        },
        labels: {
            classes: ''
        }
        
    };

    constructor(private changeDetectorRef: ChangeDetectorRef) {}
    
    ngOnInit() {
        if (this.isRequired && (!this.inputModel || this.inputModel.length === 0)) {
            this.updateButtonFull();
            this.initComponents('dropdown', 'classes', 'multiselect-box');
            this.initComponents('group', 'classes', 'multiselect-group');
            this.initComponents('labels', 'classes', 'multiselect-labels');
            this.initComponents('checkboxes', 'classes', 'multiselect-checks');
        } else {
            this.updateButtonFull();
            this.initComponents('dropdown', 'classes', 'multiselect-box');
            this.initComponents('group', 'classes', 'multiselect-group');
            this.initComponents('labels', 'classes', 'multiselect-labels');
            this.initComponents('checkboxes', 'classes', 'multiselect-checks');
        }

        if (this.inputModel !== undefined) {
            this._selected = this.inputModel.slice();
        }

    }

    updateButtonFull() {
        if (this.isRequired && (!this._selected || this._selected.length === 0)) {
            this.initComponents('caret', 'classes', 'ng-invalid caret');
            this.initComponents('caret', 'innerHTML', '<font size="20">&#9662;</font>');
            this.initComponents('caret', 'style', '');
            this.initComponents('button', 'classes', 'ng-invalid form-control multiselect-button');
            this.updateButtonValue('Required');
        } else {
            this.initComponents('caret', 'classes', 'ng-valid caret');
            this.initComponents('caret', 'innerHTML', '&#9662;');
            this.initComponents('caret', 'style', '');
            this.initComponents('button', 'classes', 'ng-valid form-control multiselect-button');
            this.updateButtonValue();
        }
    }

    updateButtonValue(value?: string) {
        if (value) {
            this.initComponents('button', 'value', value);
        } else {
            const numSelected: string = this._selected ? this._selected.length.toString() : '0';
            this.initComponents('button', 'value', numSelected + ': selected');
        }
    }

    initComponents(objectName: string, propertyName: string, behavior: any) {
        if (this.overrides && this.overrides[objectName] &&
            this.overrides[objectName][propertyName] !== undefined) {
            // overrides all behaviors
            this._object[objectName][propertyName] = this.overrides[objectName][propertyName];
        } else if (this.additions && this.additions[objectName] &&
            typeof this.additions[objectName][propertyName] !== undefined) {
            // add behavior to default
            this._object[objectName][propertyName] = this.additions[objectName][propertyName] + ' ' + behavior;
        } else {
            this._object[objectName][propertyName] = behavior;
        }
    }

    openCloseMultiselect() {
        this._object.dropdown.open = !this._object.dropdown.open;
    }

    addRemoveSelected(event, item: BasicFormModel) {
        if (event.which === 1 || event.which === 13 || event.which === 32) {
            if (event.which !== 1) {
              event.preventDefault();
              event.stopPropagation();
            }
      
            if (this.inSelectedCheckboxes(item)) {
            // needs a constant removal
              if (this.inputProperty) {
                this._selected = this.inputModel.filter(value => value[this.inputProperty] !== item.value);  
              } else {
                this._selected = this.inputModel.filter(value => value !== item.value);
              }
            this.inputModelChange.emit(this._selected);
            } else {
              if (this.inputProperty) {
                  this._selected.push(item);
              } else {
                  this._selected.push(item.value);
              }

              this.inputModelChange.emit(this._selected);
            }
      
            if (event.which === 13) {
              this._object.dropdown.open = !this._object.dropdown.open;
            }

            this.updateButtonFull();
        }
      
      
        if (event.which === 27) {
          event.preventDefault();
          event.stopPropagation();
          this._object.dropdown.open = false;
        }
    }

    inSelectedCheckboxes(item): boolean {
        for (let i = 0; i < this._selected.length; i++ ){
            if (this.inputModel[i] === item.value || 
                this.inputModel[i][this.inputProperty] === item.value) {
                return true;
            }
        }
        return false;
    }
}